module.exports = __webpack_public_path__ + "img/wallet_card2.b4831988.png";